import React, { lazy, Suspense } from 'react';
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import { wrapHistory } from "oaf-react-router";

import Header from './components/Header/Header.js';
import AboveHeader from './components/Header/AboveHeader.js';
import Home from './components/Home/Home.js';
import Packages from './components/Packages/Packages.js';
import Individual from './components/Individual/Individual.js';
import Services from './components/Services/Services.js';
import About from './components/About/About.js';
import Contact from './components/Contact/Contact.js';
import FAQ from './components/FAQ/FAQ.js';
import Checkout from './components/Checkout/Checkout.js';
import Schedule from './components/Schedule/Schedule.js';
// const Header = lazy(() => import ('./components/Header/Header.js'));
// const AboveHeader = lazy(() => import ('./components/Header/AboveHeader.js'));
// const Home = lazy(() => import ('./components/Home/Home.js'));
// const Contact = lazy(() => import ('./components/Contact/Contact.js'));
// const FAQ = lazy(() => import ('./components/FAQ/FAQ.js'));
const F404 = lazy(() => import ('./components/404/404.js'));

const renderLoader = () => <p>Loading...</p>;

const history = createBrowserHistory()

const settings = {
  // announcementsDivId: "announcements",
  primaryFocusTarget: "h1, main h1, [role=main] h1",
  // This assumes you're setting the document title via some other means (e.g. React Helmet).
  // If you're not, you should return a unique and descriptive page title for each page
  // from this function and set `setPageTitle` to true.
  // BYO localization
  // documentTitle: (location: Location) => document.title,
  navigationMessage: (title: string, location: Location, action: Action): string => `Navigated to ${title}.`,
  // Return false if you're handling focus yourself for a specific history action.
  shouldHandleAction: (previousLocation: Location, nextLocation: Location, action: Action) => true,
  disableAutoScrollRestoration: true,
  announcePageNavigation: false,
  setPageTitle: false,
  handleHashFragment: true,
  // Set this to false if you are using HashRouter or MemoryRouter.
  restorePageStateOnPop: true,
  // Set this to true for smooth scrolling.
  // For browser compatibility you might want iamdustan's smoothscroll polyfill https://github.com/iamdustan/smoothscroll
  smoothScroll: true,
};

wrapHistory(history, settings);

function App({context}) {
  return (
    <Router history={history}>
      <div className="main" id="main">
        <Suspense fallback={renderLoader()}>
          <AboveHeader />
          <Header context={context} />
            <div className="container">
            <Switch>
              <Route exact path="/" render={props => <Home context={context} {...props} />}/>
              <Route exact path="/services/" render={props => <Services context={context} {...props} />}/>
              <Route exact path="/packages/" render={props => <Packages context={context} {...props} />}/>
              <Route exact path="/individual/" render={props => <Individual context={context} {...props} />}/>
              <Route exact path="/about/" render={props => <About context={context} {...props} />}/>
              <Route exact path="/contact/" render={props => <Contact context={context} {...props} />}/>
              <Route exact path="/faq/" render={props => <FAQ context={context} {...props} />}/>
              <Route exact path="/schedule/" render={props => <Schedule context={context} {...props} />}/>
              <Route exact path="/checkout/" render={props => <Checkout context={context} {...props} />}/>
              <Route render={props => <F404 {...props} />} />
            </Switch>
            </div>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
